import constants from '../shared/constants';

document.addEventListener('DOMContentLoaded', (): void => {
    const popupLinks = document.querySelectorAll<HTMLAnchorElement>(constants.targets.popupLink);

    popupLinks.forEach((link) => {
        link.addEventListener('click', (event: MouseEvent) => {
            event.preventDefault();

            const popup = link.querySelector<HTMLElement>(constants.targets.popup);
            if (popup) {
                popup.classList.add(constants.classes.active);

                setTimeout(() => {
                    popup.classList.remove(constants.classes.active);
                }, 2000);
            }
        });
    });
});
